import { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import RootLayout from './components/layout/RootLayout'
import DashboardLayout from './pages/dashboard/DashboardLayout'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { AffiliateTracker } from './components/shared/AffiliateTracker'
import { useAuth } from './hooks/useAuth'

// Pages chargées à la demande (code-splitting) pour réduire le bundle initial
const Home = lazy(() => import('./pages/Home'))
const Pricing = lazy(() => import('./pages/Pricing').then((m) => ({ default: m.Pricing })))
const Shop = lazy(() => import('./pages/Shop'))
const HowItWorks = lazy(() => import('./pages/HowItWorks'))
const FAQ = lazy(() => import('./pages/FAQ'))
const Contact = lazy(() => import('./pages/Contact'))
const Affiliate = lazy(() => import('./pages/Affiliate'))
const Blogmarkete = lazy(() => import('./pages/Blogmarkete'))
const NotFound = lazy(() => import('./pages/NotFound'))
const Login = lazy(() => import('./pages/auth/Login'))
const Signup = lazy(() => import('./pages/auth/Signup'))
const ResetPassword = lazy(() => import('./pages/auth/ResetPassword'))
const Success = lazy(() => import('./pages/checkout/Success'))
const Cancel = lazy(() => import('./pages/checkout/Cancel'))
const Overview = lazy(() => import('./pages/dashboard/Overview'))
const Subscription = lazy(() => import('./pages/dashboard/Subscription'))
const MTAccounts = lazy(() => import('./pages/dashboard/MTAccounts'))
const Invoices = lazy(() => import('./pages/dashboard/Invoices'))
const Journals = lazy(() => import('./pages/dashboard/Journals'))
const AffiliateStats = lazy(() => import('./pages/dashboard/AffiliateStats'))
const Settings = lazy(() => import('./pages/dashboard/Settings'))
const Support = lazy(() => import('./pages/dashboard/Support'))
const Economie = lazy(() => import('./pages/dashboard/Economie'))
const AffiliateSignup = lazy(() => import('./pages/affiliate/Signup'))
const AffiliateDashboard = lazy(() => import('./pages/affiliate/Dashboard'))

function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-ink">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black dark:border-white"></div>
    </div>
  )
}

function App() {
  const { loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white dark:bg-ink">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black dark:border-white"></div>
      </div>
    )
  }

  return (
    <Router>
      <AffiliateTracker />
      <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route element={<RootLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/affiliate" element={<Affiliate />} />
          <Route path="/blogmarkete" element={<Blogmarkete />} />
        </Route>

        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/signup" element={<Signup />} />
        <Route path="/auth/reset-password" element={<ResetPassword />} />

        <Route path="/checkout/success" element={<Success />} />
        <Route path="/checkout/cancel" element={<Cancel />} />

        <Route path="/affiliate/signup" element={<AffiliateSignup />} />
        <Route path="/affiliate/dashboard" element={<ProtectedRoute><AffiliateDashboard /></ProtectedRoute>} />

        <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
          <Route index element={<Overview />} />
          <Route path="subscription" element={<Subscription />} />
          <Route path="journals" element={<Journals />} />
          <Route path="mt-accounts" element={<MTAccounts />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="affiliate" element={<AffiliateStats />} />
          <Route path="support" element={<Support />} />
          <Route path="economie" element={<Economie />} />
          <Route path="settings" element={<Settings />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
      </Suspense>
    </Router>
  )
}

export default App